/* eslint react/jsx-key: off */
import React from 'react';
import { translate } from 'react-admin';

const PackageTitle = translate(({ record, translate }) => (
    <span>
        {record ? translate('resources.packages.edit.title', { title: record.name }) : ''}
    </span>
));

export default PackageTitle;
